module.exports = __webpack_public_path__ + "img/moravian-camera.4d2233ae.jpg";